function isValidYmd(y: number, m: number, d: number): boolean {
  if (!Number.isFinite(y) || y < 1000 || y > 9999) return false
  if (!Number.isFinite(m) || m < 1 || m > 12) return false
  if (!Number.isFinite(d) || d < 1 || d > 31) return false
  const dt = new Date(y, m - 1, d)
  return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d
}

function formatYmd(y: number, m: number, d: number): string {
  return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
}

export function toHtmlDateInputValue(raw: unknown): string {
  if (raw == null) return ''
  const s = String(raw).trim()
  if (!s) return ''

  const flexible = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(s)
  if (flexible) {
    const rest = s.slice(flexible[0].length)
    if (rest === '' || /^[T\s]/.test(rest)) {
      const y = +flexible[1]
      const m = +flexible[2]
      const d = +flexible[3]
      if (isValidYmd(y, m, d)) return formatYmd(y, m, d)
    }
  }

  const slash = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(s)
  if (slash) {
    const a = +slash[1]
    const b = +slash[2]
    const y = +slash[3]
    let m: number
    let d: number
    if (a > 12) {
      d = a
      m = b
    } else if (b > 12) {
      m = a
      d = b
    } else {
      m = a
      d = b
    }
    if (isValidYmd(y, m, d)) return formatYmd(y, m, d)
  }

  const ymdSlash = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/.exec(s)
  if (ymdSlash) {
    const y = +ymdSlash[1]
    const m = +ymdSlash[2]
    const d = +ymdSlash[3]
    if (isValidYmd(y, m, d)) return formatYmd(y, m, d)
  }

  const dotEu = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s)
  if (dotEu) {
    const d0 = +dotEu[1]
    const m0 = +dotEu[2]
    const y = +dotEu[3]
    if (isValidYmd(y, m0, d0)) return formatYmd(y, m0, d0)
  }

  const t = Date.parse(s)
  if (!Number.isFinite(t)) return ''
  const dt = new Date(t)
  if (Number.isNaN(dt.getTime())) return ''
  const useUtc = /Z$/i.test(s) || /[+-]\d{2}:?\d{2}$/.test(s)
  if (useUtc) {
    return formatYmd(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate())
  }
  return formatYmd(dt.getFullYear(), dt.getMonth() + 1, dt.getDate())
}
